module.exports = __webpack_public_path__ + "img/jcb.83dd987e.png";